import React from "react";
import { MessageBox as WebMessageBox } from "../WebStyles";
import { MessageBox as WindowsMessageBox } from "../WindowsStyles";
import { MessageBox as MacMessageBox } from "../MacStyles";
import { MessageBox as LinuxMessageBox } from "../LinuxStyles";
import { MessageBox as IosMessageBox } from "../iOSStyles";
import { MessageBox as AndroidMessageBox } from "../AndroidStyles";
import { DEVICE_OS } from "@pcloud/web-utilities/dist/config/constants";

const MessageBox = ({ os, ...rest}) => {
  switch (os) {
    case DEVICE_OS.Android:
      return <AndroidMessageBox {...rest}/>
    case DEVICE_OS.iOS:
      return <IosMessageBox {...rest}/>
    case DEVICE_OS.Web:
      return <WebMessageBox {...rest}/>
    case DEVICE_OS.Win:
      return <WindowsMessageBox {...rest}/>
    case DEVICE_OS.MacOSX:
      return <MacMessageBox {...rest}/>
    case DEVICE_OS.Linux:
      return <LinuxMessageBox {...rest}/>
    default:
      return <WebMessageBox {...rest}/>
  }
};

export default MessageBox;
